import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import ListViewCard from "../../Components/ListViewCard";
import "flatpickr/dist/themes/material_orange.css";

import Flatpickr from "react-flatpickr";
import {
  Briefcase,
  Calendar,
  Check,
  DollarSign,
  Download,
  Eye,
  File,
  Grid,
  Mail,
  Map,
  MapPin,
  Menu,
  Phone,
  PhoneCall,
  User,
  UserCheck,
  X,
} from "react-feather";
import CommonModal from "../../Components/CommonModal";
import PostApiCall from "../../Api/Api";
import Notiflix from "notiflix";
import maleIcon from "../../assets/profile/user.jpeg";
import { DataTable as DataTables } from "primereact/datatable";
import { Column } from "primereact/column";

import moment from "moment";
import NoDataFound from "../../Components/NoDataFound";
import { toast } from "react-toastify";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import { useSelector } from "react-redux";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { StatusAuditNotification } from "../../Helper/NotificationMsg";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const ManageAuditorAudit = () => {
  let columnDefs = [
    {
      name: "client name",
      selector: (row) => row.fld_clientname,
      width: "200px",
    },
    {
      name: "outlet Id",
      selector: (row) => row.fld_outletid,
      width: "150px",
    },
    {
      name: "outlet Name",
      selector: (row) => row.fld_outletname,
      width: "200px",
    },
    {
      name: "Audit Start date",
      selector: (row) =>
        moment(row.fld_plannedstart?.split("T")[0]).format("ll"),
      width: "200px",
    },
    {
      name: "Audit end date",
      selector: (row) => moment(row.fld_plannedend?.split("T")[0]).format("ll"),
      width: "200px",
    },

    {
      name: "Audit Action",
      width: "200px",
      cell: (row) => (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            setModal(true);
            fetchAuditApplied(row);
            setAuditInfo(row);
            setSelectedAuditorStatus({value:row.fld_outletstatus,label:row.fld_outletstatus})
            setActiveUpto(row.fld_activeupto)
            setRecruiterRemark(row.fld_recruiterremark)
            // setAuditData(row);
          }}
        >
          <Eye size={16} /> View
        </span>
      ),
    },
  ];

  const [auditApplicant, setAuditApplicant] = useState([]);
  const [modal, setModal] = useState(false);
  const [recruiterRemark, setRecruiterRemark] = useState("");

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [auditData, setAuditData] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const user = useSelector((state) => state.login);
  const [recruiterRemarkModal, setRecruiterRemarkModal] = useState(false);
  const [activeUpto, setActiveUpto] = useState("");
  const [showAuditUserError, setAuditUserError] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [auditInfo, setAuditInfo] = useState(null);
  const [selectedAuditorStatus, setSelectedAuditorStatus] = useState(null);
  const [statuschange, setstatuschange] = useState('');

  const history =useHistory()

  const fetchAuditApplied = async (row) => {
    const resultdes = await PostApiCall.postRequest(
      {
        publisherid: row.fld_id,
        outletid: row.fld_outletid,
        auditorid:
          user.fld_usertype === "Staff" || user.fld_isadmin === 1
            ? 0
            : user.fld_id,
      },
      "GetAuditRequest"
    );
    const { data } = await resultdes.json();

    setAuditApplicant(data);
  };

  const getPublishAudithandler = async () => {
    Notiflix.Loading.standard();
    try {
      const res = await PostApiCall.postRequest(
        { id: user.fld_id },
        "Job_GetRequestAuditorList"
      );
      const { data } = await res.json();
      setAuditData(data);
      setFilteredData(data);
      Notiflix.Loading.remove();
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
  };

  const FetchAppiedUserAudit = async () => {
    const resultdes = await PostApiCall.postRequest(
      {
        publisherid: 0,
        outletid: 0,
        auditorid: user.fld_id,
      },
      "GetAuditRequest"
    );
    const { data } = await resultdes.json();

    setAuditApplicant(data);
  };
  useEffect(() => {
    if (user.fld_isadmin === 1 || user.fld_usertype === "Staff") {
      getPublishAudithandler();
    } else {
      FetchAppiedUserAudit();
    }
  }, []);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!recruiterRemark) {
      newErrors.recruiterRemark = "Remarks is required";
    }
    if (auditInfo?.fld_outletstatus ===selectedAuditorStatus) {
      newErrors.Status = "Status must be changed.";
    }
    if (!activeUpto) {
      newErrors.activeUpto = "User Active date is required.";
    }

    if(auditInfo?.fld_scheduledate === null ){
      newErrors.fld_scheduledate = "Audit Schedule date is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const submitForm = async () => {
    if(auditInfo.fld_outletstatus!==selectedAuditorStatus.value){
      const isValid = validateForm();
    if (isValid) {
      const totalId = selectedStaff
        .map((item) => item.fld_id.toString())
        .join(",");

      Notiflix.Loading.standard();
      PostApiCall.postRequest(
        {
          id: auditInfo.fld_id,
          outletid:auditInfo.fld_outletid,
          scheduledate: auditInfo.fld_scheduledate,
          address: auditInfo.fld_address,
          recruiterremark:recruiterRemark,
          activeupto:activeUpto,
          outletstatus:selectedAuditorStatus.value,
          status:auditInfo.fld_status
        },
        "UpdateJobPublishList"
      ).then((results) =>
        results.json().then(async (obj) => {
          if (results.status === 200 || results.status === 201) {
            const resultdes = await PostApiCall.postRequest(
              {
                id: totalId,
                status: selectedAuditorStatus.value,
                recruiterremark: recruiterRemark,
                activeupto: activeUpto,
                updatedat: moment().format("ll"),
                updatedby: user.fld_id[0],
                auditorstatus: "Pending",
              },
              "UpdateAuditRequest"
            );
            if (resultdes.ok) {
              toast.success("Request send for Acceptable", {
                autoClose: delay,
              });
              let apiPromises = selectedStaff.map((ele) => {
                let status = StatusAuditNotification(
                  selectedAuditorStatus.value,
                  "Audit"
                );
                return PostApiCall.postRequest(
                  {
                    ...status,
                    updatedat: moment().format("ll"),
                    senderid: user.fld_id,
                    receiverid: ele.fld_auditorid,
                    usertype: "user",
                  },
                  "Job_AddNotification"
                ).then((results) => {
                  return results.json().then((data) => {
                    if (results.status === 200 || results.status === 201) {
                      return true;
                    } else {
                      return false;
                    }
                  });
                });
              });
              Promise.all(apiPromises).then((results) => {
                const allSuccessful = results.some((result) => result);
                if (allSuccessful) {
                  Notiflix.Loading.remove();
                  window.location.reload()
                } else {
                  throw new Error(SomethingWrong);
                }
              });
            } else {
              Notiflix.Loading.remove();

              toast.error(SomethingWrong, {
                autoClose: delay,
                toastId: 1,
              });
            }
          }
        })
      );

      setModal(false);
      setRecruiterRemarkModal(false);
    }
    }else{
      setstatuschange('Please change the audit status')
    }
    
  };
  const toggleModal = () => {
    setModal(!modal);
  };

  const handleCancel = () => {
    // Your cancel logic
    setModal(false);
  };

  const toggleDetailsModal = () => {
    setShowDetailModal(!showDetailModal);
  };

  const handleDetailsCancel = () => {
    // Your cancel logic
    setShowDetailModal(false);
  };
  const updateSearchQuery = (e) => {
    setSearchVal(e.target.value);
    filterData(e.target.value);
  };
  const filterData = (search) => {
    const filtered = auditData.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      // const statusMatches =
      //   !filter ||
      //   filter.value === "All" ||
      //   item.fld_applicationstatus === filter.value;
      return searchMatches;
    });

    setFilteredData(filtered);
  };

  return (
    <div className="container-fluid">
      {auditData?.length > 0 ? (
        <div
          className="p-2 mt-2 container-fluid"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)", border: "none" }}
        >
          <Row className="filter-actions my-2 justify-content-between">
            <Col sm="12" md="3">
              <Input
                style={{
                  border: "#cccccc solid 1px",
                  height: "38px",
                  borderRadius: "5px",
                }}
                className=" mr-1 shadow-sm"
                type="text"
                placeholder="search..."
                onChange={updateSearchQuery}
                value={searchVal}
              />
            </Col>
          </Row>

          <DataTable
            highlightOnHover
            className="dataTable-custom mt-2"
            data={filteredData}
            columns={columnDefs}
            fixedHeader
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onRowClicked={(row) => {
              setModal(true);
              fetchAuditApplied(row);

            setRecruiterRemark(row.fld_recruiterremark)

              setAuditInfo(row);
              setSelectedAuditorStatus({value:row.fld_outletstatus,label:row.fld_outletstatus})
              
            setActiveUpto(row.fld_activeupto)

            }}
            customStyles={{
              head: {
                style: {
                  background: "transparent", // Remove the default background color
                },
              },
              headRow: {
                style: {
                  backgroundColor: "white",
                  color: "#ca8636",
                },
              },
              headCells: {
                style: {
                  fontSize: "14px",
                  textTransform: "capitalize",
                },
              },
            }}
          />
        </div>
      ) : (
        <div>
          <NoDataFound />
        </div>
      )}
      {modal === true && (
        <CommonModal
          isOpen={modal}
          toggle={toggleModal}
          heading={`Audit Request List`}
          modalSize={"lg"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              <DataTables
                highlightOnHover={true}
                value={auditApplicant}
                selectionMode={"checkbox"}
                selection={selectedStaff}
                onSelectionChange={(e) => {
                  setAuditUserError(false);
                  setSelectedStaff(e.value);
                }}
                dataKey="fld_id"
                tableStyle={{ minWidth: "50rem" }}
                paginator={true}
                rows={3}
                style={{ fontSize: "13px" }}
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "3rem", color: "#ca8636" }}
                ></Column>

                <Column
                  field="fld_name"
                  header="Name"
                  // tableStyle={{  width: "400px"}}
                  headerStyle={{ color: "#ca8636", width: "200px" }}
                ></Column>
                <Column
                  field="fld_email"
                  header="Email"
                  // tableStyle={{  width: "400px"}}
                  headerStyle={{ color: "#ca8636", width: "200px" }}
                ></Column>
                <Column
                  field="fld_mobile"
                  header="Contact"
                  headerStyle={{ color: "#ca8636", width: "200px" }}
                ></Column>
                <Column
                  field="fld_auditstatus"
                  header="Audit Status"
                  headerStyle={{ color: "#ca8636", width: "200px" }}
                  body={(rowData) => (
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "200px" }}
                    >
                      <span
                        className={`${genareteColor(
                          rowData.fld_auditstatus
                        )} font-size-3 rounded-3 px-2`}
                      >
                        {rowData.fld_auditstatus==='InProgress'? 'Reviewed':rowData.fld_auditstatus}
                      </span>
                      {/* {rowData.fld_auditstatus} */}
                    </div>
                  )}
                />

                <Column
                  field="fld_auditorstatus"
                  header="Auditor Status"
                  headerStyle={{ color: "#ca8636", width: "200px" }}
                  body={(rowData) => (
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "200px" }}
                    >
                      <span
                        className={`${genareteColor(
                          rowData.fld_auditorstatus
                        )} font-size-3 rounded-3 px-2`}
                      >
                        {rowData.fld_auditorstatus}
                      </span>
                      {/* {rowData.fld_auditstatus} */}
                    </div>
                  )}
                />

                <Column
                  body={(rowData) => (
                    <div
                      onClick={() => {
                        setShowDetailModal(true);
                        setSelectedUser(rowData);
                      }}
                    >
                      View
                    </div>
                  )}
                  header="Action"
                  headerStyle={{ color: "#ca8636" }}
                  style={{ width: "150px", cursor: "pointer" }}
                ></Column>
              </DataTables>
              {
               showAuditUserError && 
             <div className="text-center text-danger">
              Please select the user to process
             </div>
              }
          
            </div>
          }
          onConfirm={() => {
            if (selectedStaff.length > 0) {
              setAuditUserError(false);
              setRecruiterRemarkModal(true);
            }else{
              setAuditUserError(true);
            }
          }}
          confirmText={"Process"}
          cancelText={"Cancel"}
          onCancel={handleCancel}
        />
      )}

      {showDetailModal === true && (
        <CommonModal
          isOpen={showDetailModal}
          toggle={toggleDetailsModal}
          heading={"User Detail"}
          contentBody={
            <div>
              <div className="d-flex">
                <img
                  src={
                    process.env.REACT_APP_FILE_PATH_URL + selectedUser.fld_photo
                  }
                  alt="User"
                  width={"80px"}
                  height={"80px"}
                  className="shadow"
                  onError={(e) => (e.target.src = maleIcon)}
                />
                <div className="ml-3">
                  <p style={{ color: "black" }}>
                    Name :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_name}
                    </span>
                  </p>
                  <p style={{ color: "black" }}>
                    Email :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_email}
                    </span>
                  </p>
                  <p style={{ color: "black" }}>
                    Phone No :{" "}
                    <span style={{ color: "gray" }}>
                      {selectedUser.fld_mobile}
                    </span>
                  </p>
                </div>
              </div>
              <FormGroup className="mt-3">
                <Label htmlFor="">Preference Cities</Label>
                <Input
                  type="textarea"
                  name="name"
                  id="nameVertical"
                  className="rounded-0 py-2"
                  value={selectedUser.work_preference}
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col sm="6">
                    <Label htmlFor="">Prices Accepted</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={selectedUser.fld_price === 1 ? "Yes" : "No"}
                      disabled
                    />
                  </Col>
                  <Col sm="6">
                    <Label htmlFor="">Proposed Date</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={moment(selectedUser.fld_purposaldate).format("ll")}
                      disabled
                    />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="exampleText">Auditor Remarks</Label>
                <Input
                  id="exampleText"
                  name="text"
                  type="textarea"
                  className="py-2"
                  
                  value={selectedUser.fld_auditorremark}
                />
              </FormGroup>
            </div>
          }
          cancelText={"Cancel"}
          onCancel={handleDetailsCancel}
        />
      )}
      {recruiterRemarkModal === true && (
        <CommonModal
          isOpen={recruiterRemarkModal}
          toggle={() => setRecruiterRemarkModal(false)}
          heading={"Remarks"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              <div
                className="dropdown actions-dropdown my-2"
                style={{ zIndex: 20 }}
              >
                <Label for="nameVertical">
                  Status
                  <span className="mandatory">*</span>
                </Label>
                <Select
                  className=""
                  classNamePrefix="select"
                  placeholder="status"
                  name="color"
                  options={[
                    { value: "Pending", label: "Pending" },
                    { value: "Reviewed", label: "Reviewed" },
                    { value: "Approved", label: "Approved" },
                    { value: "Rejected", label: "Rejected" },
                  ]}
                  onChange={(selectedOption) =>{
                   
                    setstatuschange("")
                    setSelectedAuditorStatus(selectedOption)}
                  }
                  value={selectedAuditorStatus}
                />
                <p className="text-danger font-size-3">{errors.Status}</p>
              </div>
              <Label for="nameVertical">
                Recruiter Remarks
                <span className="mandatory">*</span>
              </Label>
              <Input
                type="textarea"
                className="w-100 mt-1"
                placeholder="Message ..."
                value={auditInfo.fld_recruiterremark}
                style={{ height: "100px", paddingLeft: "10px" }}
                onChange={(e) => {
                  setRecruiterRemark(e.target.value)
                  setAuditInfo((prev) => ({
                    ...prev,
                    fld_recruiterremark: e.target.value,
                  }));
                }}
              />
              <p className="text-danger font-size-3">
                {errors.recruiterRemark}
              </p>
              <FormGroup className="mt-3">
                <Label for="">
                  Audit Schedule Date<span className="mandatory">*</span>
                </Label>
                <Flatpickr
                  className="form-control"
                  value={[moment(auditInfo.fld_scheduledate).format()]}
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    minDate: new Date().fp_incr(0),
                  }}
                  onChange={(e) => {
                    setAuditInfo((prev) => ({
                      ...prev,
                      fld_scheduledate: moment(e[0]).format("YYYY-MM-DD"),
                    }));
                  }}
                />
                <p className="text-danger font-size-3">{errors.fld_scheduledate}</p>
              </FormGroup>
              <FormGroup>
                <Label for="">
                  Active Upto<span className="mandatory">*</span>
                </Label>
                <Flatpickr
                  className="form-control"
                  value={[moment(activeUpto).format()]}
                  options={{
                    altInput: true,
                    altFormat: "F j, Y",
                    dateFormat: "Y-m-d",
                    minDate: new Date().fp_incr(0),
                  }}
                  onChange={(e) => {
                    setActiveUpto(moment(e[0]).format('YYYY-MM-DD'));
                  }}
                />
                <p className="text-danger font-size-3">{errors.activeUpto}</p>
              </FormGroup>
              {
                statuschange!=='' && 
              <p className="text-danger font-size-3">{statuschange}</p>
              }
            </div>
          }
          onConfirm={submitForm}
          confirmText={"submit"}
          // acceptText={<Check size={15} />}
          // rejectText={<X size={15} />}
          cancelText={"Cancel"}
          onCancel={() => setRecruiterRemarkModal(false)}
        />
      )}
    </div>
  );
};

export default ManageAuditorAudit;
